import { API_GET_RAYONS_BY_GOROD_ID, MAIN_URL, PORT } from "../../../constants/constants";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { getCityByObl, getGorod, getRayon } from "../../../utilities";

export const headerOptions = {
  inputsOptions: {
    regNum: {
      key: "regNum",
      label: "Регистрационный номер маломерного судна",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    personType: {
      key: "personType",
      label: "Субъект хозяйствования",
      type: "selectWithSearch",
      fieldModeView: true,
      needInForm: true,
      options: [
        { label: "Физическое лицо", value: 1, key: "personType" },
        { label: "Юридическое лицо", value: 2, key: "personType" },
      ],
    },
  },
};

export const interestedPersonIndividual = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-individual-view",
  blockVisibility: true,
  inputsOptions: {
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: true,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    serialOfPassport: {
      key: "serialOfPassport",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    numberOfPassport: {
      key: "numberOfPassport",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 14,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
    },
    stranId: {
      key: "stranId",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "Республика Беларусь",
    },
    oblId: {
      key: "oblId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    rayonId: {
      key: "rayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    gorodId: {
      key: "gorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    ulica: {
      key: "ulica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
      upperCase: true,
    },
    dom: {
      key: "dom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
      upperCase: true,
    },
    korpus: {
      key: "korpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    kv: {
      key: "kv",
      label: "Квартира",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerPhone: {
      key: "ownerPhone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Недопустимые символы: введите цифры, (), -, +`,
      },
    },
  },
};

export const interestedEntity = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-entity-view",
  blockVisibility: true,
  inputsOptions: {
    nameLe: {
      key: "nameLe",
      label: "Наименование ЮЛ",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docDepartmentLe: {
      key: "docDepartmentLe",
      label: "Наименование гос. организации, осуществляющей регистрацию",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    egrNum: {
      key: "egrNum",
      label: "Единый  ЕГРЮЛиИП",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 8,
    },
    unp: {
      key: "unp",
      label: "УНП",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 8,
    },
    stranId: {
      key: "stranId",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "Республика Беларусь",
    },
    oblId: {
      key: "oblId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    rayonId: {
      key: "rayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    gorodId: {
      key: "gorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    ulica: {
      key: "ulica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
    },
    dom: {
      key: "dom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
      upperCase: true,
    },
    korpus: {
      key: "korpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    kv: {
      key: "kv",
      label: "Квартира (офис)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerPhone: {
      key: "ownerPhone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
  },
};

export const representPerson = {
  caption: "Сведения о представителе заинтересованного лица",
  gridKey: "grid-container-represent",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    agentSurname: {
      key: "agentSurname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentName: {
      key: "agentName",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentMidname: {
      key: "agentMidname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentDocType: {
      key: "agentDocType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
      upperCase: true,
    },
    agentSerialOfPassport: {
      key: "agentSerialOfPassport",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[a-zA-Z]{2}$/,
        message: `Введите 2 латинские буквы`,
      },
    },
    agentNumberOfPassport: {
      key: "agentNumberOfPassport",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
      upperCase: true,
    },
    agentDocDate: {
      key: "agentDocDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
          return "Дата не может быть ранее 26.09.1996";
        } else {
          return true;
        }
      },
    },
    agentDocDepartment: {
      key: "agentDocDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentPersNum: {
      key: "agentPersNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      upperCase: true,
    },
    agentCountry: {
      key: "agentCountry",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "Республика Беларусь",
      upperCase: true,
    },
    agentOblId: {
      key: "agentOblId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
      upperCase: true,
    },
    agentRayonId: {
      key: "agentRayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
      upperCase: true,
    },
    agentGorodId: {
      key: "agentGorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
      upperCase: true,
    },
    agentUlica: {
      key: "agentUlica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
      upperCase: true,
    },
    agentDom: {
      key: "agentDom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
      upperCase: true,
    },
    agentKorpus: {
      key: "agentKorpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentKv: {
      key: "agentKv",
      label: "Квартира",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentPhone: {
      key: "agentPhone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
      upperCase: true,
    },
    agentDoverennost: {
      key: "agentDoverennost",
      label: "Сведения о доверенности",
      type: "text",
      textarea: true,
      rows: 3,
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
  },
};

export const boatInfo = {
  caption: "Сведения о маломерном судне",
  gridKey: "grid-container-boat-info-view",
  blockVisibility: true,
  inputsOptions: {
    boatName: {
      key: "boatName",
      label: "Название (при наличии)",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    boatVin: {
      key: "boatVin",
      label: "Заводской (идентификационный) номер",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    boatYear: {
      key: "boatYear",
      label: "Год постройки",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    tiketNum: {
      key: "tiketNum",
      label: "Номер судового билета",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    operDate: {
      key: "operDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      needInForm: true,
    },
    boatType: {
      key: "boatType",
      label: "Тип",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    boatVid: {
      key: "boatVid",
      label: "Вид",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    engPower: {
      key: "engPower",
      label: "Предельная мощность двигателей, л.с.",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    engineNum: {
      key: "engineNum",
      label: "Количество двигателей",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    engpwrSum: {
      key: "engpwrSum",
      label: "Мощность двигателей, л.с.",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
    engvinList: {
      key: "engvinList",
      label: "Заводской номер двигателя",
      type: "text",
      fieldModeView: true,
      needInForm: true,
    },
  },
};

export const optionsForPasswordModal = {
  caption: "Пароль ЭЦП",
  gridKey: "",
  blockVisibility: true,
  inputsOptions: {
    pw: {
      key: "pw",
      label: "Пароль",
      type: "password",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
  },
};

export const isNeedToPaySelector = {
  key: "isNeedToPaySelector",
  label: "Выставить счет на оплату",
  type: "selectWithSearch",
  placeholder: "Выберите",
  fieldModeView: false,
  disabled: false,
  isSearchable: false,
  required: true,
  needInForm: true,
  options: [
    {
      value: true,
      label: "Да",
      key: "isNeedToPaySelector",
    },
    {
      value: false,
      label: "Нет",
      key: "isNeedToPaySelector",
    },
  ],
};

export function setDocOptionsDocumentsFromDictionariesInterested(docLib) {
  if (docLib.length > 0) {
    const validLibInterested = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (interestedPersonIndividual.inputsOptions.docType.options.length === 0) {
      interestedPersonIndividual.inputsOptions.docType.options.push(...validLibInterested);
    }
  }
}
export function setOblOptionsFromDictionariesInterested(oblLib, type) {
  const validLibInterested = oblLib.map((item) => {
    return {
      ...item,
      key: "oblId",
    };
  });

  if (interestedPersonIndividual.inputsOptions.oblId.options.length === 0) {
    interestedPersonIndividual.inputsOptions.oblId.options.push(...validLibInterested);
  }
  if (interestedEntity.inputsOptions.oblId.options.length === 0) {
    interestedEntity.inputsOptions.oblId.options.push(...validLibInterested);
  }
}

export function setDocOptionsDocumentsFromDictionariesRepresent(docLib) {
  if (docLib.length > 0) {
    const validLibRepresent = docLib.map((item) => {
      return {
        ...item,
        key: "agentDocType",
      };
    });
    if (representPerson.inputsOptions.agentDocType.options.length === 0) {
      representPerson.inputsOptions.agentDocType.options.push(...validLibRepresent);
    }
  }
}
export function setOblOptionsFromDictionariesRepresent(oblLib) {
  const validLibRepresent = oblLib.map((item) => {
    return {
      ...item,
      key: "agentOblId",
    };
  });
  if (representPerson.inputsOptions.agentOblId.options.length === 0) {
    representPerson.inputsOptions.agentOblId.options.push(...validLibRepresent);
  }
}
export async function setOptionsInterestedPerson(value, key, type) {
  if (!!type) {
    if (!!value[key]) {
      if (type === 1) {
        switch (key) {
          case "oblId": {
            if (Number(value[key]) === 5) {
              interestedPersonIndividual.inputsOptions.rayonId.options = [];
              interestedPersonIndividual.inputsOptions.rayonId.disabled = true;
              interestedPersonIndividual.inputsOptions.rayonId.required = false;
              interestedPersonIndividual.inputsOptions.gorodId.options = [];
              interestedPersonIndividual.inputsOptions.gorodId.disabled = true;
              interestedPersonIndividual.inputsOptions.gorodId.required = false;
              return interestedPersonIndividual;
            } else {
              const rayons = await getRayon(value[key]);
              const cities = await getCityByObl(value[key]);
              const rayonsValid =
                rayons?.map((item) => {
                  item.key = "rayonId";
                  return item;
                }) || [];
              interestedPersonIndividual.inputsOptions.rayonId.options = rayonsValid;
              interestedPersonIndividual.inputsOptions.rayonId.disabled = interestedPersonIndividual
                .inputsOptions.rayonId.options.length
                ? false
                : true;
              interestedPersonIndividual.inputsOptions.rayonId.required = false;
              interestedPersonIndividual.inputsOptions.gorodId.options = cities;
              interestedPersonIndividual.inputsOptions.gorodId.disabled = false;
              interestedPersonIndividual.inputsOptions.gorodId.required = true;

              return interestedPersonIndividual;
            }
          }
          case "rayonId": {
            if (!value.gorodId) {
              const gorod = await getGorod(value[key]);
              const gorodValid =
                gorod?.map((item) => {
                  item.key = "gorodId";
                  return item;
                }) || [];
              interestedPersonIndividual.inputsOptions.gorodId.options = gorodValid;
              interestedPersonIndividual.inputsOptions.gorodId.disabled = interestedPersonIndividual
                .inputsOptions.gorodId.options.length
                ? false
                : true;
            }
            return interestedPersonIndividual;
          }
          case "gorodId": {
            if (value[key]) {
              const selectedOptions = interestedPersonIndividual.inputsOptions.gorodId.options?.find(
                (item) => value[key] === item.value,
              );
              if (selectedOptions) {
                if (selectedOptions?.label.includes("г.")) {
                  interestedPersonIndividual.inputsOptions.rayonId.required = false;
                } else {
                  interestedPersonIndividual.inputsOptions.rayonId.required = true;
                }
              }
              const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

              if (request.ok) {
                const response = await request.json();
                const rayonsValid =
                  response?.map((item) => {
                    return {
                      value: item.id,
                      label: item.name,
                      key: "rayonId",
                    };
                  }) || [];
                interestedPersonIndividual.inputsOptions.rayonId.options = rayonsValid;
                interestedPersonIndividual.inputsOptions.rayonId.disabled = interestedPersonIndividual
                  .inputsOptions.rayonId.options.length
                  ? false
                  : true;
              }
            }

            return interestedPersonIndividual;
          }
          default:
            return interestedPersonIndividual;
        }
      } else {
        switch (key) {
          case "oblId": {
            if (Number(value[key]) === 5) {
              interestedEntity.inputsOptions.rayonId.options = [];
              interestedEntity.inputsOptions.rayonId.disabled = true;
              interestedEntity.inputsOptions.rayonId.required = false;
              interestedEntity.inputsOptions.gorodId.options = [];
              interestedEntity.inputsOptions.gorodId.disabled = true;
              interestedEntity.inputsOptions.gorodId.required = false;
              return interestedEntity;
            } else {
              const rayons = await getRayon(value[key]);
              const cities = await getCityByObl(value[key]);
              const rayonsValid =
                rayons?.map((item) => {
                  item.key = "rayonId";
                  return item;
                }) || [];
              interestedEntity.inputsOptions.rayonId.options = rayonsValid;
              interestedEntity.inputsOptions.rayonId.disabled = interestedEntity.inputsOptions.rayonId.options
                .length
                ? false
                : true;
              interestedEntity.inputsOptions.rayonId.required = true;
              interestedEntity.inputsOptions.gorodId.options = cities;
              interestedEntity.inputsOptions.gorodId.disabled = false;
              interestedEntity.inputsOptions.gorodId.required = true;

              return interestedEntity;
            }
          }
          case "rayonId": {
            if (!value.gorodId) {
              const gorod = await getGorod(value[key]);
              const gorodValid =
                gorod?.map((item) => {
                  item.key = "gorodId";
                  return item;
                }) || [];
              interestedEntity.inputsOptions.gorodId.options = gorodValid;
              interestedEntity.inputsOptions.gorodId.disabled = interestedEntity.inputsOptions.gorodId.options
                .length
                ? false
                : true;
            }
            return interestedEntity;
          }
          case "gorodId": {
            const selectedOptions = interestedEntity.inputsOptions.gorodId.options.find(
              (item) => value[key] === item.value,
            );
            if (selectedOptions?.label.includes("г.")) {
              interestedEntity.inputsOptions.rayonId.required = false;
            } else {
              interestedEntity.inputsOptions.rayonId.required = true;
            }
            const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

            if (request.ok) {
              const response = await request.json();
              const rayonsValid =
                response?.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                    key: "rayonId",
                  };
                }) || [];
              interestedEntity.inputsOptions.rayonId.options = rayonsValid;
              interestedEntity.inputsOptions.rayonId.disabled = interestedEntity.inputsOptions.rayonId.options
                .length
                ? false
                : true;
            }
            return interestedEntity;
          }
          default:
            return interestedEntity;
        }
      }
    } else {
      return type === 1 ? interestedPersonIndividual : interestedEntity;
    }
  }
}
export async function setOptionsRepresentPerson(value, key, type) {
  switch (key) {
    case "agentOblId": {
      if (Number(value[key]) === 5) {
        representPerson.inputsOptions.agentRayonId.options = [];
        representPerson.inputsOptions.agentRayonId.disabled = true;
        representPerson.inputsOptions.agentGorodId.options = [];
        representPerson.inputsOptions.agentGorodId.disabled = true;

        representPerson.inputsOptions.agentRayonId.required = false;
        representPerson.inputsOptions.agentGorodId.required = false;

        return representPerson;
      } else {
        const rayons = await getRayon(value[key]);
        const rayonsValid =
          rayons?.map((item) => {
            item.key = "agentRayonId";
            return item;
          }) || [];
        const cities = await getCityByObl(value[key]);
        const citiesValid =
          cities?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentRayonId.options = rayonsValid;
        representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
          .options.length
          ? false
          : true;
        representPerson.inputsOptions.agentGorodId.options = citiesValid;
        representPerson.inputsOptions.agentGorodId.disabled = false;

        if (type === 2) {
          representPerson.inputsOptions.agentRayonId.required = true;
          representPerson.inputsOptions.agentGorodId.required = true;
        }
        return representPerson;
      }
    }
    case "agentRayonId": {
      if (!value.agentGorodId) {
        const gorod = await getGorod(value[key]);
        const gorodValid =
          gorod?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentGorodId.options = gorodValid;
        representPerson.inputsOptions.agentGorodId.disabled = representPerson.inputsOptions.agentGorodId
          .options.length
          ? false
          : true;
      }
      return representPerson;
    }
    case "agentGorodId": {
      const selectedOptions = representPerson.inputsOptions.agentGorodId.options.find(
        (item) => value[key] === item.value,
      );

      if (type === 2) {
        if (selectedOptions.label.includes("г.")) {
          representPerson.inputsOptions.agentRayonId.required = false;
        } else {
          representPerson.inputsOptions.agentRayonId.required = true;
        }
      }
      const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

      if (request.ok) {
        const response = await request.json();
        const rayonsValid =
          response?.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: "agentRayonId",
            };
          }) || [];
        representPerson.inputsOptions.agentRayonId.options = rayonsValid;
        representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
          .options.length
          ? false
          : true;
      }
      return representPerson;
    }
    default:
      return representPerson;
  }
}

export function setGridsByMode(mode, typeId) {
  if (mode === "add" || mode === "edit") {
    interestedPersonIndividual.gridKey = "grid-container-individual";
    interestedEntity.gridKey = "grid-container-entity";
    representPerson.gridKey = "grid-container-represent";
    if (typeId === 2) {
      for (let item in representPerson.inputsOptions) {
        if (item !== "agentUlica" && item !== "agentKorpus" && item !== "agentKv") {
          representPerson.inputsOptions[item].required = true;
        }
      }
    } else {
      for (let item in representPerson.inputsOptions) {
        representPerson.inputsOptions[item].required = false;
      }
    }
  } else {
    interestedPersonIndividual.gridKey = "grid-container-individual-view";
    interestedEntity.gridKey = "grid-container-entity-view";
    representPerson.gridKey = "grid-container-represent-view";
  }
  return {
    interestedIndividual: interestedPersonIndividual,
    interestedEntity: interestedEntity,
    represent: representPerson,
  };
}
